// @flow
import React from 'react'

import { WEB_TYPES_KEYS } from '../../Redux/SettingsRedux'

// components
import QuoteHelpComponent from './QuoteHelpComponent'

// types
import type { ColumnTypeDefaultProps } from './ColumnTypeDefault'

const ColumnTypeName = (props: ColumnTypeDefaultProps) => {
  const handleOpenHelp = () => {
    props.onOpenHelp()
  }

  let insuranceCompany = {}
  if (props.insuranceCompanies[props.data.insuranceCompany]) {
    insuranceCompany = props.insuranceCompanies[props.data.insuranceCompany]
  }
  let logo = ''
  if (props.data.icon && props.data.icon[WEB_TYPES_KEYS[props.webType]]) {
    logo = props.data.icon[WEB_TYPES_KEYS[props.webType]]
  } else if (insuranceCompany.webLogo) {
    logo = insuranceCompany.webLogo
  }
  return [
    !props.columnConfig.hideLogo && !!logo && (
      <>
        <img
          alt={insuranceCompany.name}
          className="my-2 cursor-pointer"
          key={`quote-insuranceCompany-logo-${insuranceCompany.name}`}
          onClick={handleOpenHelp}
          src={logo}
          width={80}
        />
        <span className={`quote-insuranceCompany-logo quote-insuranceCompany-logo-${props.data.insuranceCompany}`} />
      </>
    ),
    props.data.name && !!props.data.name.default && (
      <strong
        className="align-middle d-lg-block mt-lg-1 ml-4 ml-lg-0 text-wrap cursor-pointer"
        id={`ID${props.columnConfig.key}-quote-${props.quote.id}-help-mobile-wrapper`}
        key={`quote-insuranceCompany-name-${insuranceCompany.name}`}
        onClick={handleOpenHelp}
      >
        {props.data.name[WEB_TYPES_KEYS[props.webType]]}
      </strong>
    ),
    <div
      className="help px-2 d-inline-block d-lg-none float-right"
      key={`quote-insuranceCompany-help-${insuranceCompany.name}`}
    >
      {!!props.data.help && (
        <QuoteHelpComponent
          documents={props.documents}
          help={props.data.help}
          id={`ID${props.columnConfig.key}-quote-${props.quote.id}-help-mobile`}
          onClose={props.onCloseHelp}
          templateVariables={props.templateVariables}
        />
      )}
    </div>,
  ]
}

export default ColumnTypeName
